import type { ActionToastProps as ActionToastType, LinkToastProps as LinkToastType, BaseToast as ToastType } from './types';

export function isLinkToast(toast: LinkToastType | ToastType): toast is LinkToastType {
  return (toast as LinkToastType).link !== undefined;
}

export function isActionToast(toast: ActionToastType | ToastType): toast is ActionToastType {
  return (toast as ActionToastType).action !== undefined;
}
